import eventNames from '../eventNames';
import track from '../track';

type BaseTrackClickedParams = {
  site: string;
  moduleName: string;
};

type BaseTrackClickedParamsWithText = BaseTrackClickedParams & {
  text: string;
};

type TrackTextClickedParams = BaseTrackClickedParamsWithText & {
  component: 'text';
};

type TrackButtonClickedParams = BaseTrackClickedParamsWithText & {
  component: 'button';
};

type TrackCheckboxClickedParams = BaseTrackClickedParams & {
  component: 'checkbox';
  checked: boolean;
};

type TrackClickedParams =
  | TrackTextClickedParams
  | TrackButtonClickedParams
  | TrackCheckboxClickedParams;

export function trackClicked(params: TrackClickedParams) {
  track(eventNames.clicked, params);
}
